import React from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const { FaEnvelope, FaExternalLinkAlt, FaUsers } = FaIcons;

const AboutContact = () => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 pb-20">
      <section
        id="about"
        className="glass-card p-8 mt-8 scroll-mt-8"
        aria-labelledby="about-heading"
      >
        <div className="flex items-start gap-4">
          <div className="mt-1 text-xl text-primary-light" aria-hidden="true">
            <SafeIcon icon={FaUsers} />
          </div>

          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-light">
              關於我們 · About
            </p>
            <h2
              id="about-heading"
              className="text-2xl font-bold text-white mb-4"
            >
              誰在營運 QR星球?
            </h2>
            <p className="text-slate-400 leading-7">
              QR星球（QR Planet）由
              <a
                href="https://homy.hk/"
                target="_blank"
                rel="author noopener noreferrer"
                className="text-primary-light hover:text-white transition-colors mx-1 underline underline-offset-4"
              >
                Homy Tech
              </a>
              建立及維護。Homy Tech 專注於實用、易用和重視私隱的數碼工具，
              讓個人、品牌及企業能免費建立專業的 QR Code。使用者無需註冊，
              輸入內容也不會上傳至伺服器。
            </p>
          </div>
        </div>
      </section>

      <section
        id="contact"
        className="glass-card p-8 mt-8 scroll-mt-8"
        aria-labelledby="contact-heading"
      >
        <div className="flex items-start gap-4">
          <div className="mt-1 text-xl text-primary-light" aria-hidden="true">
            <SafeIcon icon={FaEnvelope} />
          </div>

          <div>
            <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-light">
              聯絡我們 · Contact
            </p>
            <h2
              id="contact-heading"
              className="text-2xl font-bold text-white mb-4"
            >
              如何聯絡 QR星球團隊?
            </h2>
            <address className="text-slate-400 leading-7 not-italic">
              如有使用問題、合作建議或功能意見，請透過 Homy Tech
              官方網站提供的聯絡渠道與 QR星球團隊聯絡。
            </address>
            <a
              href="https://homy.hk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-5 px-4 py-2.5 rounded-lg border border-primary/30 bg-primary/10 text-primary-light font-medium hover:bg-primary/20 hover:text-white transition-colors"
              aria-label="前往 Homy Tech 官方網站聯絡 QR星球團隊"
            >
              前往 Homy Tech 官方網站
              <SafeIcon icon={FaExternalLinkAlt} aria-hidden="true" />
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutContact;